import { Injectable } from '@angular/core';
import { ActionNotificationComponent } from './../_shared/action-natification/action-notification.component'
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteEntityDialogComponent } from './../_shared/delete-entity-dialog/delete-entity-dialog.component';
import { FetchEntityDialogComponent } from './../_shared/fetch-entity-dialog/fetch-entity-dialog.component';
import { UpdateStatusDialogComponent } from './../_shared/update-status-dialog/update-status-dialog.component';
import moment from 'moment';
import 'moment-timezone';
import { WaitingDialogComponent } from '@core/_shared/waiting-dialog/waiting-dialog.component';
import { GeneralDeleteEntityDialogComponent } from '@core/_shared/general-delete-entity-dialog/general-delete-entity-dialog.component';
import { GeneralPictureEntityDialogComponent } from '@core/_shared/general-picture-entity-dialog/general-picture-entity-dialog.component';
import { IptalDialogComponent } from '@core/_shared/delete-entity-dialog/iptal-dialog.component';
import { GeneralMessageEntityDialogComponent } from '@core/_shared/general-message-entity-dialog/general-message-entity-dialog.component';
import { UrlDialogComponent } from '@core/_shared/url-dialog/url-dialog.component';
import { ConfirmEntityDialogComponent } from '@core/_shared/confirm-dialog/confirm-entity-dailog.component';
import { GeneralMessageSetButtonsTextDialogComponent } from '@core/_shared/general-message-set-buttons-text-dialog/general-message-set-buttons-text-dialog.component';
import { GeneralPdfViewerDialogComponent } from '@core/_shared/general-pdf-viewer-dialog/general-pdf-viewer-dialog.component';
import { GeneralSharedMessageSetButtonsTextDialogComponent } from '@core/_shared/general-shared-message-set-buttons-text-dialog/general-shared-message-set-buttons-text-dialog.component';

export enum MessageType {
    Create,
    Read,
    Update,
    Delete,
    Success,
    Info,
    Error,
    Warning
}

@Injectable()
export class LayoutUtilsService {
    constructor(private snackBar: MatSnackBar,
        private dialog: MatDialog) { }

    // SnackBar for notifications
    showActionNotification(
        message: string,
        type: MessageType = MessageType.Create,
        duration: number = 3000,
        showCloseButton: boolean = true,
        showUndoButton: boolean = false,
        isHtml = false,
        undoButtonDuration: number = 3000,
        verticalPosition: 'top' | 'bottom' = 'top',
    ) {
        return this.snackBar.openFromComponent(ActionNotificationComponent, {
            duration: duration,
            panelClass: [
                type == MessageType.Create ? 'green-snackbar' :
                    type == MessageType.Read ? 'blue-snackbar' :
                        type == MessageType.Update ? 'green-snackbar' :
                            type == MessageType.Delete ? 'red-snackbar' :
                                type == MessageType.Success ? 'green-snackbar' :
                                    type == MessageType.Info ? 'blue-snackbar' :
                                        type == MessageType.Error ? 'red-snackbar' :
                                            type == MessageType.Warning ? 'yellow-snackbar' : 'mat-snack-bar-container'
            ],
            data: {
                message,
                snackBar: this.snackBar,
                showCloseButton: showCloseButton,
                showUndoButton: showUndoButton,
                undoButtonDuration,
                verticalPosition,
                type,
                action: 'Undo',
                isHtml: isHtml
            },
            verticalPosition: verticalPosition
        });
    }

    // Method returns instance of MatDialog
    // Evet/Hayır Buttons Dialog
    deleteElement(title: string = '', description: string = '', waitDesciption: string = '') {
        return this.dialog.open(DeleteEntityDialogComponent, {
            data: { title, description, waitDesciption },
            width: '440px'
        });
    }

    iptalElementWithMessage(title: string = '', description: string = '', waitDesciption: string = '', entityTitle: string = '') {
        return this.dialog.open(IptalDialogComponent, {
            data: { title, description, waitDesciption, entityTitle },
            width: '440px'
        });
    }

    // Method returns instance of MatDialog
    // Evet/Hayır Buttons Dialog
    generalDeleteElement(title: string = '', description: string = '', waitDesciption: string = '', service: any, id: number) {
        return this.dialog.open(GeneralDeleteEntityDialogComponent, {
            data: { title, description, waitDesciption, service, id },
            width: '440px'
        });
    }

    // Genel Resim Gösterme Dialog
    generalPictureDialogElement(title: string = '', pathOrbase64string: string | ArrayBuffer = '', link: string = '') {
        return this.dialog.open(GeneralPictureEntityDialogComponent, {
            data: { title, pathOrbase64string, link },
            panelClass: ['full-screen-modal']
        });
    }

    // Genel Base64 Pdf Gösterme Dialog
    generalPdfViewerDialogElement(title: string, pdfData: string | ArrayBuffer) {
        return this.dialog.open(GeneralPdfViewerDialogComponent, {
            data: { title, pdfData },
            panelClass: ['full-screen-modal']
        });
    }

    confirmElementWithMessage(title: string = '', description: string = '', waitDesciption: string = '', entityTitle: string = '') {
        return this.dialog.open(ConfirmEntityDialogComponent, {
            data: { title, description, waitDesciption, entityTitle },
            width: '440px'
        });
    }

    // Method returns instance of MatDialog
    // Evet/Hayır Buttons Dialog
    generalMessageElement(title: string = '', description: string = '') {
        return this.dialog.open(GeneralMessageEntityDialogComponent, {
            data: { title, description },
            width: '440px'
        });
    }

    generalMessageSetButtonsText(title: string = '', description: string = '', button1: string = '', button2: string = '', button3: string = '', button4: string = '') {
        return this.dialog.open(GeneralMessageSetButtonsTextDialogComponent, {
            data: { title, description, button1, button2 , button3, button4},
            width: '440px'
        });
    }

    generalSharedMessageSetButtonsText(title: string = '', description: string = '', button1: string = '', button2: string = '') {
        return this.dialog.open(GeneralSharedMessageSetButtonsTextDialogComponent, {
            data: { title, description, button1, button2 },
            width: '640px'
        });
    }

    // Method returns instance of MatDialog
    fetchElements(_data) {
        return this.dialog.open(FetchEntityDialogComponent, {
            data: _data,
            width: '400px'
        });
    }

    // Method returns instance of MatDialog
    updateStatusForCustomers(title, statuses, messages) {
        return this.dialog.open(UpdateStatusDialogComponent, {
            data: { title, statuses, messages },
            width: '480px'
        });
    }

    // Method returns instance of MatDialog
    // İptal Button Dialog
    waitProcess(title: string = '', waitDesciption: string = '') {
        return this.dialog.open(WaitingDialogComponent, {
            data: { title, waitDesciption },
            width: '440px'
        });
    }

    convertToTurkishTimezone(date): any {
        var momentDate = moment(date);
        var targetDate = momentDate.clone().tz("Europe/Istanbul").format();
        return targetDate;
    };

    convertToTurkishTimezoneWithoutTime(date): any {
        var momentDate = moment(date);
        var targetDate = momentDate.clone().tz("Europe/Istanbul").format("DD/MM/YYYY");
        return targetDate;
    };

    getUtcDate(year, month, date): Date {
        return new Date(Date.UTC(year, month, date));
    }

    // Method returns instance of MatDialog
    // URL Dialog
    UrlElement(url: string = '') {
        return this.dialog.open(UrlDialogComponent, {
            data: { url },
            width: '550px',
            height: '450px'
        });
    }
}
